const inFlightGets = new Map<string, Promise<unknown>>()

export function getInFlightGet(key: string): Promise<unknown> | undefined {
  return inFlightGets.get(key)
}

export function setInFlightGet(key: string, promise: Promise<unknown>): void {
  inFlightGets.set(key, promise)
}

export function deleteInFlightGet(key: string): void {
  inFlightGets.delete(key)
}

export function clearAllInFlightGets(): void {
  inFlightGets.clear()
}
